

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import PStorage, { USER_ID, USERNAME } from '@/util/PStorage'
import { RootState } from '@/store/types'
import { Darkness } from '@/store/ui/types'
import { UI_SET_DARKNESS } from '@/store/ui/constants'

@Component({ name: 'v-page' })
export default class VPage extends Vue {
    username: string = PStorage.getOrDefault(USERNAME, null)

    @Prop({ type: Boolean, default: false })
    showLoginButtons!: boolean

    @Prop({ type: Boolean, default: false })
    boxed!: boolean

    @Prop({ type: Boolean, default: false })
    showDarknessToggle!: boolean

    @State((state: RootState) => state.ui.darkness)
    darkness!: Darkness

    @Mutation(UI_SET_DARKNESS)
    setDarkness!: (darkness: Darkness) => void
}
